import { render } from "./DataQualityScorecardTable.vue?vue&type=template&id=13bf70a0"
import script from "./DataQualityScorecardTable.vue?vue&type=script&lang=js"
export * from "./DataQualityScorecardTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__